// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6b098952","488":"f8d96079","977":"13776955"}[chunkId] + ".chunk.js";
};